import Skeleton from 'react-loading-skeleton';
import useMainStore from '@/store/mainStore';

export default function Name() {
  const studioInstance = useMainStore((state) => state.studioInstance);

  if (!studioInstance?.publicData.asset.name)
    return (
      <Skeleton
        height={40}
        width={200}
      />
    );

  return (
    <div className="m-claim--text-xl m-claim--text-primary">
      {studioInstance?.publicData.asset.name}
    </div>
  );
}
